import { Injectable, signal, computed } from '@angular/core';

export interface ExtranetNotification {
  id: string;
  type: string;
  icon: string;
  title: string;
  body: string;
  time: string;
  read: boolean;
  color: string;
  bookingId?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  // No in-app notification backend exists yet (be-hotel-extranet-service has no notification-feed
  // endpoint) — this starts empty rather than showing fabricated data as if it were real. See
  // design-proposals/fe-hilbertech-extranet-web/live-audit-2026-07-13.md for the tracked follow-up.
  readonly notifications = signal<ExtranetNotification[]>([]);
  readonly unreadCount = computed(() => this.notifications().filter(n => !n.read).length);

  markAllRead() {
    this.notifications.update(ns => ns.map(n => ({ ...n, read: true })));
  }

  markRead(id: string) {
    this.notifications.update(ns => ns.map(n => n.id === id ? { ...n, read: true } : n));
  }
}
